<app-modal-container
  [title]="'Invite co-admin'"
  [bigSize]="false"
  [spinnerProps]="spinnerProps"
  [buttons]="modalButtons"
  [formGroup]="teamMemberForm"
  [applyActivated]="teamMemberForm.valid"
  (applyButtonClicked)="onApply()"
  (dismissButtonClicked)="onCancel()">

  <div class="!w-[22rem] flex flex-col items-center self-stretch gap-y-[1rem]">

    <!-- Warning Block -->
    <div class="self-stretch bg-color-orange-2-opacity-0p3 br-0p5 border-orange-10 p-[0.5rem] flex flex-row items-center justify-start gap-[0.5rem]">
      <app-all-icons class="orange-10 icon-size-2" [iconNameAndStyling]="'exclamation-triangle.svg'"/>
      <span class="font-3 bold500">
        Invited users can manage models inside <br>the system
      </span>
    </div>

    <!-- Email Field -->
    <app-input
      data-qa="team-member-email"
      class="!w-full"
      formControlName="email"
      [title]="'Email'"
      [required]="true"
      [autocomplete]="'off'"
      [inputID]="'team-member-email'"
      [placeholder]="'email@email.com'"
      [suffixFirstIcon]="teamMemberForm.value.email ? 'close.svg' : undefined"
      (suffixFirstIconEmitter)="resetForm()"
    />

    <!-- Admin Switcher -->
    <div class="w-full flex flex-row items-center justify-start gap-[0.5rem]">
      <app-switcher
        data-qa="team-member-admin-switcher"
        formControlName="isAbleToManageUsers"
        class="medium-switcher"
        [checked]="teamMemberForm.value.isAbleToManageUsers"
      />
      <span class="font-3 font-normal">Can manage users</span>
    </div>
  </div>
</app-modal-container>
